import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { SiteFooter } from "./SiteFooter";

type PageLayoutProps = {
  children: ReactNode;
  backTo?: string;
  backLabel?: string;
};

export function PageLayout({
  children,
  backTo = "/",
  backLabel = "← Back to homepage",
}: PageLayoutProps) {
  return (
    <main className="min-h-screen flex flex-col items-center px-5 pt-8 pb-12">
      <article className="w-full max-w-[680px] bg-white/85 backdrop-blur-[1px] px-5 sm:px-8 pt-9 pb-10 relative animate-ink-in">
        <Link
          viewTransition
          to={backTo}
          className="text-[0.85rem] caps-label text-[rgba(31,29,25,0.6)] hover:text-[#7b5b33] mb-6 inline-block"
        >
          {backLabel}
        </Link>
        {children}
      </article>
      <SiteFooter />
    </main>
  );
}
